<template>
  <mdb-container :class="currentGroup && $route.params.groupId ? '' : 'gp-has-header'">
    <banner-small :group="currentGroup" title="Card Pages" v-if="currentGroup && $route.params.groupId"/>
    <div class="text-left">
      <mdb-btn @click="createModal = true" icon="plus" size="sm" rounded>
        Create New Card Page
      </mdb-btn>
      <mdb-btn @click="$router.push('/cards/about-card-pages')" icon="question" size="sm" rounded>
        Explain Card Pages</mdb-btn>

      <mdb-tbl>
        <mdb-tbl-head>
          <tr>
            <th>Name</th>
            <th>Url Name</th>
            <th></th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-bind:key="card.id" v-for="card in cards">
            <td>{{ card.name }}</td>
            <td>{{ card.urlName }}</td>
            <td>
              <mdb-btn @click="editCard(card)" floating icon="pencil-alt"
                       size="sm"
                       tag="a" type=""/>
              <mdb-btn @click.native="viewCard(card)" floating icon="eye"
                       size="sm"
                       tag="a" type=""/>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
    <mdb-modal @close="createModal = false" info position="top-center" scrollable
               size="lg" v-if="createModal">
      <mdb-modal-header>
        <p class="heading">New Card Page</p>
      </mdb-modal-header>
      <mdb-modal-body>
         <mdb-input type="text" placeholder="Card Page Name" v-model="newName" label="Page Name"/>
      </mdb-modal-body>
      <mdb-modal-footer>
          <mdb-btn rounded size="sm" @click="create" :disabled="newName==''" icon="save">
            Save
          </mdb-btn>
        <mdb-btn color="danger" rounded size="sm" @click="createModal = false" icon="minus-circle">
          Cancel
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

  </mdb-container>

</template>
<script>
import editor from '@tinymce/tinymce-vue'
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from "../group/BannerSmall";
import {
  mdbBtn,
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
  name: "system-cards",
  display: "Card Pages",
  order: 1,
  components: {
    mdbContainer,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbInput,
    editor,
    bannerSmall
  },
  data() {
    return {
      cards: [],
      createModal : false,
      newName: ""
    }
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    currentGroup: function () {
      return this.$store.state.currentGroup
    }
  },
  async mounted() {
    document.title = "Card Pages"
    let url = "/card/list"
    if (this.$route.params.groupId) {
      await api.groupBasics(this.$route.params.groupId, "member")
      url += "?group=" + this.$route.params.groupId
    }
    await this.$store.dispatch("setExecuting", true)
    api.get(url).then(
      (details) => {
        this.cards = details.data
      },
      (error) => {
        this.$notify.error({message: "Error getting cards."})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    create: function () {
      this.createModal = false
      this.$store.dispatch("setExecuting", true)
      let payload = {name: this.newName}
      if (this.$route.params.groupId) payload.group = this.$route.params.groupId
      api.post("/card/create/", payload).then(
        (details) => {
          if (this.$route.params.groupId) this.$router.push("/group/" + this.currentGroup.vanityPath + "/card-page/" + details.data.id)
          else this.$router.push("/admin/card-page/" + details.data.id)
        },
        (error) => {
          this.$notify.error({message: "Error saving card page."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    viewCard: function (page) {
      if (this.$route.params.groupId) window.open("/group/" + this.currentGroup.vanityPath + "/cards/" + page.urlName, '_blank');
      else window.open("/cards/" + page.urlName, '_blank');
    },
    editCard: function (page) {
      if (this.$route.params.groupId) this.$router.push("/group/" + this.currentGroup.vanityPath + "/card-page/" + page.id)
      else this.$router.push("/admin/card-page/" + page.id)
    },
  }
};
</script>
